export default function FCASection() {
  return (
    <section className="fca-investigation" data-testid="fca-investigation-section">
      <h2>What the FCA Investigation Found</h2>
      <p className="fca-sub">Understanding undisclosed commission in car finance agreements</p>

      <div className="fca-grid">
        {/* Left: FCA Findings */}
        <div className="fca-findings-card" data-testid="fca-findings-card">
          <h3>FCA Findings</h3>
          <p>Between 2007 and 2024, many car dealerships arranged finance on behalf of customers. In these arrangements, dealers often received commission payments from finance providers.</p>

          <p className="fca-findings-label">WHAT THE FCA FOUND IN SOME CASES</p>

          <div className="fca-finding-item">
            <div className="fca-warning-icon">!</div>
            <span>Commission amounts were not disclosed to customers</span>
          </div>
          <div className="fca-finding-item">
            <div className="fca-warning-icon">!</div>
            <span>Higher interest rates may have been applied to increase commission payments</span>
          </div>
          <div className="fca-finding-item">
            <div className="fca-warning-icon">!</div>
            <span>Customers were not given information that could have affected their decision</span>
          </div>

          <div className="fca-estimate-box" data-testid="fca-estimate-box">
            <p className="fca-estimate-label">FCA ESTIMATE</p>
            <p className="fca-estimate-text">Approximately 12.1m agreements may be affected</p>
          </div>
        </div>

        {/* Right: How It Happened */}
        <div className="fca-timeline-card" data-testid="fca-timeline-card">
          <h3>How It Happened</h3>

          <div className="timeline-item">
            <h4>Finance Agreement Signed</h4>
            <p>You took out car finance through a dealership</p>
          </div>
          <div className="timeline-connector"><span className="tl-dot" /></div>

          <div className="timeline-item">
            <h4>Commission Arrangement</h4>
            <p>The dealer received commission from the finance provider</p>
          </div>
          <div className="timeline-connector"><span className="tl-dot" /></div>

          <div className="timeline-item amber">
            <h4>Not Disclosed</h4>
            <p>This commission may not have been made clear to you</p>
          </div>
          <div className="timeline-connector"><span className="tl-dot" /></div>

          <div className="timeline-item">
            <h4>FCA Investigation</h4>
            <p>The FCA found widespread issues with these arrangements</p>
          </div>
          <div className="timeline-connector"><span className="tl-dot" /></div>

          <div className="timeline-item green">
            <h4>Your Right to Claim</h4>
            <p>You may be entitled to compensation</p>
          </div>

          <div className="fca-eligible">
            <div className="fca-eligible-icon">&#10003;</div>
            <p>If your agreement included these arrangements, you may be eligible for compensation.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
